import React from 'react';
import PropTypes from 'prop-types';
import useSLPExternalAPI from '../../sale-page/hooks/useSLPExternalAPI';

/**
 * Wrapper component that installs the external SLP API for AB testing
 * This component uses the useSLPExternalAPI hook to expose window.hpSlpAPI
 *
 * @param {string} searchKey - Unique identifier for this search instance
 * @param {ReactNode} children - Child components
 */
const SearchAPIProvider = ({ searchKey, children }) => {
    // Install the external API
    useSLPExternalAPI(searchKey);

    // Simply render children - the hook handles API installation
    return <>{children}</>;
};

SearchAPIProvider.propTypes = {
    searchKey: PropTypes.string.isRequired,
    children: PropTypes.node,
};

export default SearchAPIProvider;
